// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

//引入vue路由组件
import router from './router'

import 'echarts/lib/chart/pie'
// import 'echarts/lib/component/graphic'

// 引入 Vant UI
import Vant, {Toast, Dialog,Lazyload,Sticky} from 'vant';
import 'vant/lib/index.css';
import '@/common/css/common.css'

// 引入图标库iconfont
import '@/common/font/iconfont/iconfont.css'

// import Vconsole from 'vconsole'   		//移动端调试工具之一：vconsole
// const vConsole = new Vconsole()
// Vue.use(vConsole)

// 引入mock.js
require('./mock/mock.js')

Vue.use(Vant);

Vue.use(Lazyload);

Vue.use(Sticky);
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
//引入axios
import axios from 'axios'
import {post, fetch, patch, put} from '@/common/js/http'
import {formatDate, formatNumber} from '@/common/js/format'

//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$formatNumber = formatNumber;

let obj = {
  $sessionSet: function (name, value, json = false) {
    if (json) {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(name, value)
  },
  $sessionGet: function (name, json = false) {
    let value = sessionStorage.getItem(name);
    if (json) {
      value = JSON.parse(value);
    }
    return value;
  },
  $sessionRemove: function (name) {
    sessionStorage.removeItem(name)
  },
}

Vue.prototype = Object.assign(Vue.prototype, obj);

//引入登录
import '@/common/js/login'

import {configShare} from '@/common/js/common'
configShare();

Vue.config.productionTip = false

Vue.mixin({
  beforeRouteLeave: function (to, from, next) {
    // console.log(to,from)
    let clear_list=[];

    if (to.name === 'tenantRoom') {
      clear_list=['tenantAdd','tenantAddNext']
    }
    if (to.name === 'RoomNumberList') {
      clear_list=['editHouse','addRoomNumber','IdleRoomTenant']
    }
    if (to.name === 'houseIndex') {
      clear_list=['addHouse','RoomNumberList','batchAddRoom','batchConfigList','addRoomNumber','IdleRoomEdit']
    }

    if (to.name === 'addRoomNumber') {
      clear_list=['housePhoto']
    }

    if (to.name === 'batchConfigList') {
      clear_list=['batchConfigItem']
    }

    if (to.name === 'batchAddRoom') {
      clear_list=['batchConfigList']
    }

    if (to.name === 'addHouse') {
      clear_list=['batchAddRoom','addRoomNumber','IdleRoomEdit']
    }

    if (to.name === 'IdleRoom') {
      clear_list=['IdleRoomTenant']
    }

    if (to.name === 'IdleRoomTenant') {
      clear_list=['IdleRoomCheck','tenantAdd','tenantAddNext','tenantComplete','billList','billDetail','IdleRoomEdit']
    }

    if (to.name === 'billList') {
      clear_list=['billAdd','billAddOther','tenantInfo','billDetail']
    }

    if (to.name === 'billDetail') {
      clear_list=['billReadMeter','billAdd']
    }

    if (to.name === 'tenantInfo') {
      clear_list=['billDetail']
    }

    if (to.name === 'readMeterCenter') {
      clear_list=['readMeterDetail']
    }

    if (to.name === 'HomePage') {
      clear_list=['accountReceivable','owner','tenant','IdleRoom','accountUnpaid','accountFlowWater','ownerExpire','statisticalReport','accountReceipt','summaryTable','hire']
    }

    if (to.name === 'accountReceivable') {
      clear_list=['billList','tenantInfo','billDetail','billConfirm']
    }

    if (to.name === 'accountReceipt') {
      clear_list=['billDetail']
    }

    if (to.name === 'accountUnpaid') {
      clear_list=['billDetailOther']
    }

    if (to.name === 'accountFlowWater') {
      clear_list=['billDetail','billDetailOther']
    }

    if (to.name === 'summaryTableList') {
      clear_list=['summaryTableAdd']
    }

    if (to.name === 'tenant') {
      clear_list=['billList','tenantInfo','billDetail','billConfirm','tenantSelectHouse','tenantAdd','tenantAddNext','tenantComplete','tenantHistory']
    }

    if (to.name === 'tenantHistory') {
      clear_list=['billList']
    }

    if (to.name === 'my') {
      clear_list=['putForward']
    }

    if (to.name === 'ownerBillList') {
      clear_list=['ownerInfo']
    }

    if (to.name === 'ownerInfo') {
      clear_list=['ownerAdd']
    }

    if (to.name === 'owner') {
      clear_list=['ownerBillList','ownerBillDetail','ownerBillConfirm','ownerInfo','ownerAdd','ownerHistory']
    }

    if (to.name === 'ownerHistory'||to.name === 'ownerExpire') {
      clear_list=['ownerBillList','ownerInfo']
    }

    if (to.name === 'summaryTable') {
      clear_list=['summaryTableInfo','summaryTableList']
    }

    if (to.name === 'summaryTableList') {
      clear_list=['summaryTableInfo','summaryTableAdd']
    }

    if (to.name === 'summaryTableInfo') {
      clear_list=['summaryTableAdd']
    }

    if (to.name === 'userIndex') {
      clear_list=['ownerBillList']
    }

    if (to.name === 'ownerBillList') {
      clear_list=['ownerBillDetail']
    }

    if (to.name === 'hire') {
      clear_list=['IdleRoomEdit','tenantSelectHouse','hireDetail','hireList']
    }

    if (to.name === 'hireList') {
      clear_list=['hireDetail']
    }


    let clearCache = (cache, i) => {
      let tag = cache[i].tag.split('-');
      let key = tag[2];
      if (cache[key]) {
        var index = keys.indexOf(key);
        if (index > -1) {
          keys.splice(index, 1);
        }
        delete cache[key];
      }
    }

    if (clear_list.length) {
      // console.log(to,clear_list,'main');
      if (this.$vnode && this.$vnode.data.keepAlive) {
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          if (this.$vnode.componentOptions) {
            // var key = this.$vnode.key == null
            //   ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
            //   : this.$vnode.key;
            var cache = this.$vnode.parent.componentInstance.cache;  //缓存列表
            var keys = this.$vnode.parent.componentInstance.keys;    //页面路径列表
            let exit=false;
            for(let i in cache){
              let tag=cache[i].tag;
              for(let o in clear_list){
                let last_tag=tag.split('-');
                last_tag=last_tag[last_tag.length-1]
                if (last_tag===clear_list[o]) {
                  // console.log(last_tag,clear_list[o],'找到了')
                  clearCache(cache, i);
                  exit=true;
                  break;
                }
              }
            }
            if(exit){
              this.$destroy();
            }
          }
        }
      }
    }

    next();
  },
});

/* eslint-disable no-new */
new Vue({
  // el: '#app',
  router,
  // components: { App },
  // template: '<App/>'
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js